import { render, staticRenderFns } from "./CodeKeyTable.vue?vue&type=template&id=1bc2d1e2&"
import script from "./CodeKeyTable.vue?vue&type=script&lang=ts&"
export * from "./CodeKeyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports